import React from 'react';
import { useGetLangDirectionApp } from '../../../stores/app.store';

type Props = {
    label?: string,
    children: React.ReactNode
}

const RadioBtnsContainer = ({ children, label = '' }: Props) => {

    const langDirApp = useGetLangDirectionApp();
    const isLtr = langDirApp === 'ltr';

    const style: React.CSSProperties = isLtr ? { display: 'flex', flexDirection: 'column', paddingRight: '1.5rem', paddingLeft: '0' } : { display: 'flex', flexDirection: 'column' }

    return (
        <div className="form-check" style={style}>

            {label ? <label className="form-check-label pb-2">{label}</label> : ''}

            <div style={{ display: 'flex', flexDirection: 'row', columnGap: '1rem' }}>
                {children}
            </div>
        </div>
    );
}

export default RadioBtnsContainer;